<div class="d-flex flex-row justify-content-between align-items-center" *ngIf="!loading">
    <div class="pagination-info">
        {{ 'pagination_info_1' | translate }} <span style="font-weight: 500;">{{ currentPage }}</span>
        <span *ngIf="pageAmount != 0 && pageAmount != 1 "> {{ 'pagination_info_2' | translate }}
            <span style="font-weight: 500;">{{ pageAmount }}</span></span>
    </div>
    <!-- <div class="pagination">
        <div class="button" (keydown)="prevPage()" (click)="prevPage()" tabindex="0">
            <img src="../../../assets/icons/chevron-left.svg" class="img-rotate" alt="Arrow left" />
        </div>
        <ng-container *ngFor="let generatePage of pages">
            <div *ngIf="generatePage === -1" class="button">...</div>
            <div *ngIf="generatePage !== -1" class="button"
                [ngClass]="{ 'button-selected': generatePage === currentPage }" (click)="setPage(generatePage)"
                (keydown)="setPage(generatePage)" tabindex="0">
                {{ generatePage }}
            </div>
        </ng-container>
        <div class="button" (keydown)="nextPage()" (click)="nextPage()" tabindex="0">
            <img src="../../../assets/icons/chevron-left.svg" alt="Arrow right" />
        </div>
    </div> -->

    <div>
        <div *ngIf="pageAmount <= 7" class="pagination">
            <div class="button" (click)="goToPage(currentPage - 1)">
                <img style="transform: rotate(180deg)" src="../../../assets/icons/chevron-left.svg" class="img-rotate"
                    alt="Arrow left" />
            </div>

            <div *ngFor="let page of pagesToShow">
                <div *ngIf="checkAmout >= page" class="button" [ngClass]="{ 'button-selected': page === currentPage }"
                    (click)="goToPage(page)">
                    {{page}}
                </div>

            </div>


            <div class="button" (click)="goToPage(currentPage + 1)">
                <img src="../../../assets/icons/chevron-left.svg" alt="Arrow right" />
            </div>
        </div>


        <!-- MORE THAN 8 PAGES -->
        <div *ngIf="pageAmount > 7" class="pagination">
            <div class="button" (click)="goToPage(currentPage - 1)">
                <img style="transform: rotate(180deg)" src="../../../assets/icons/chevron-left.svg"
                    class="img-rotate" />
            </div>

            <!-- FIRST BUTTON -->
            <div class="button" [ngClass]="{ 'button-selected': currentPage == 1 }" (click)="goToPage(1)">
                1
            </div>

            <span *ngIf="shouldShowLeftEllipsis" class="button">...</span>

            <div *ngFor="let page of pagesToShow" class="button" [ngClass]="{ 'button-selected': page === currentPage }"
                (click)="goToPage(page)">
                {{ page }}
            </div>

            <span *ngIf="shouldShowRightEllipsis" class="button">...</span>

            <!-- LAST BUTTON -->

            <div class="button" [ngClass]="{ 'button-selected': currentPage == checkAmout }"
                (click)="goToPage(pageAmount)">
                {{ pageAmount }}
            </div>


            <div class="button" (click)="goToPage(currentPage + 1)">
                <img src="../../../assets/icons/chevron-left.svg" alt="Arrow right" />
            </div>
        </div>
    </div>








</div>